module.exports = __webpack_public_path__ + "img/ic_video.1a3c04b4.svg";